function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 222,
  height: 280,
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 136V144V170",
  stroke: "white",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M111 60V68V76H47V92.5",
  stroke: "white",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 128V136V144H111V160.5",
  stroke: "white",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M111 60V68V76H175V92.5",
  stroke: "white",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 87,
  y: 16,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#6CE2FE",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_4983_80111)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95 34C95 32.8954 95.8954 32 97 32H103V56H95V34Z",
  fill: "#CEFCFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119 40H125C126.105 40 127 40.8954 127 42V56H119V40Z",
  fill: "#CEFCFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_4983_80111)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M103 26C103 24.8954 103.895 24 105 24H117C118.105 24 119 24.8954 119 26V56H103V26Z",
  fill: "#E1FEFF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M108 49C108 48.4477 108.448 48 109 48H113C113.552 48 114 48.4477 114 49V56H108V49Z",
  fill: "#47CFFD"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 88,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#B3C6FC",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 101C33 100.448 33.4477 100 34 100H42.382C42.7607 100 43.107 100.214 43.2764 100.553L45 104H33V101Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d_4983_80111)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33 104H59C60.1046 104 61 104.895 61 106V122C61 123.105 60.1046 124 59 124H35C33.8954 124 33 123.105 33 122V104Z",
  fill: "#E8EEFD"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M111 64V72V98",
  stroke: "white",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M175 134V142V168",
  stroke: "white",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M175 182V190V216",
  stroke: "white",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_d_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 87,
  y: 88,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#B3C6FC",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97 101C97 100.448 97.4477 100 98 100H106.382C106.761 100 107.107 100.214 107.276 100.553L109 104H97V101Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_d_4983_80111)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M97 104H123C124.105 104 125 104.895 125 106V122C125 123.105 124.105 124 123 124H99C97.8954 124 97 123.105 97 122V104Z",
  fill: "#E8EEFD"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_d_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 151,
  y: 88,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#B3C6FC",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161 101C161 100.448 161.448 100 162 100H170.382C170.761 100 171.107 100.214 171.276 100.553L173 104H161V101Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_d_4983_80111)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M161 104H187C188.105 104 189 104.895 189 106V122C189 123.105 188.105 124 187 124H163C161.895 124 161 123.105 161 122V104Z",
  fill: "#E8EEFD"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_d_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 151,
  y: 152,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#9FB4F9",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161 165C161 164.448 161.448 164 162 164H170.382C170.761 164 171.107 164.214 171.276 164.553L173 168H161V165Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_d_4983_80111)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M161 168H187C188.105 168 189 168.895 189 170V186C189 187.105 188.105 188 187 188H163C161.895 188 161 187.105 161 186V168Z",
  fill: "#E8EEFD"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_d_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 151,
  y: 216,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#DE9EFF",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 232,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 232,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter13_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 248,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter14_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 248,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter15_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 248,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter16_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 248,
  r: 4,
  fill: "#F6E8FE"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter17_d_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 152,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#DE9EFF",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter18_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 168,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter19_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 168,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter20_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 184,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter21_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 184,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter22_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 184,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter23_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 184,
  r: 4,
  fill: "#F6E8FE"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter24_d_4983_80111)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 87,
  y: 152,
  width: 48,
  height: 48,
  rx: 4,
  fill: "#DE9EFF",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter25_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 168,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter26_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 168,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter27_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 184,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter28_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 184,
  r: 4,
  fill: "#F6E8FE"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter29_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 184,
  r: 6,
  fill: "#EED0FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter30_d_4983_80111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 184,
  r: 4,
  fill: "#F6E8FE"
}))));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 221,
  height: 279,
  stroke: "#CDDBFE"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_4983_80111",
  x: 75,
  y: 12,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_4983_80111",
  x: 91,
  y: 20,
  width: 40,
  height: 56,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_4983_80111",
  x: 11,
  y: 84,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d_4983_80111",
  x: 21,
  y: 92,
  width: 52,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_d_4983_80111",
  x: 75,
  y: 84,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_d_4983_80111",
  x: 85,
  y: 92,
  width: 52,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_d_4983_80111",
  x: 139,
  y: 84,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_d_4983_80111",
  x: 149,
  y: 92,
  width: 52,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_d_4983_80111",
  x: 139,
  y: 148,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_d_4983_80111",
  x: 149,
  y: 156,
  width: 52,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_d_4983_80111",
  x: 139,
  y: 212,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_d_4983_80111",
  x: 161,
  y: 220,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_d_4983_80111",
  x: 163,
  y: 222,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter13_d_4983_80111",
  x: 153,
  y: 236,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14_d_4983_80111",
  x: 155,
  y: 238,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter15_d_4983_80111",
  x: 169,
  y: 236,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter16_d_4983_80111",
  x: 171,
  y: 238,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter17_d_4983_80111",
  x: 11,
  y: 148,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter18_d_4983_80111",
  x: 33,
  y: 156,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19_d_4983_80111",
  x: 35,
  y: 158,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter20_d_4983_80111",
  x: 25,
  y: 172,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter21_d_4983_80111",
  x: 27,
  y: 174,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter22_d_4983_80111",
  x: 41,
  y: 172,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter23_d_4983_80111",
  x: 43,
  y: 174,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter24_d_4983_80111",
  x: 75,
  y: 148,
  width: 72,
  height: 72,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter25_d_4983_80111",
  x: 97,
  y: 156,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter26_d_4983_80111",
  x: 99,
  y: 158,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter27_d_4983_80111",
  x: 89,
  y: 172,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter28_d_4983_80111",
  x: 91,
  y: 174,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter29_d_4983_80111",
  x: 105,
  y: 172,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter30_d_4983_80111",
  x: 107,
  y: 174,
  width: 24,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.25098 0 0 0 0 0.32549 0 0 0 0 0.690196 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4983_80111"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4983_80111",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4983_80111"
}, /*#__PURE__*/React.createElement("rect", {
  width: 222,
  height: 280,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_4983_80111"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white",
  transform: "translate(95 24)"
})));

function SvgOrganizationHierarchy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 280,
    viewBox: "0 0 222 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationHierarchy);
export default __webpack_public_path__ + "static/media/organization-hierarchy.d2520fba89d7082b5fb25293138c38d2.svg";
export { ForwardRef as ReactComponent };